module.exports = __webpack_public_path__ + "img/earning-to-paid.1c6aa562.svg";